export const GenreMarquee = ({ genres = [] }) => {
  const items = genres.length ? genres : ["Action", "Romance", "Fantasy", "Sci-Fi", "Slice of Life", "Cyberpunk"];
  const row = [...items, ...items];
  return (
    <div data-testid="genre-marquee" className="kp-marquee relative border-y border-white/[0.06] py-5 overflow-hidden bg-[#0F0D16]/60">
      <div className="kp-marquee-track gap-10 px-5">
        {row.map((g, i) => (
          <span key={i} className="flex items-center gap-10 font-display font-bold text-2xl sm:text-3xl uppercase tracking-tight whitespace-nowrap">
            <span className={i % 2 ? "kp-outline-text" : "text-white"}>{g}</span>
            <span className="w-2 h-2 rotate-45 bg-[#FF2A55]" />
          </span>
        ))}
      </div>
    </div>
  );
};
